import styled from "styled-components";

export const ULContainer = styled.ul`

color: ${({theme})=>theme.colors.primary};

`